
import Vue from 'vue'

export default Vue.extend({
  props: ['html_code'],
  mounted() {
    const content = this.$refs.content as Element

    Array.from(content.getElementsByTagName('script')).forEach(scriptTag => {
      if (scriptTag.hasAttribute('src')) {
        let scriptEl = document.createElement('script')
        for (let i = 0; i < scriptTag.attributes.length; i++) {
          const attr = scriptTag.attributes.item(i)!
          scriptEl.setAttribute(attr.name, attr.value)
        }
        scriptTag.remove()
        content.appendChild(scriptEl)
      }
      eval(scriptTag.innerText)
    })
  },
})
